import * as React from "react";
import styled from "styled-components";

import { AppLayout } from "./AppLayout";

const bmftrLogo = require("../../assets/BMFTR_Logo.svg.png");
const bild1 = require("../../assets/Bild_1.png");
const bild2 = require("../../assets/Bild_2.png");
const bild3 = require("../../assets/Bild_3.png");
const bild4 = require("../../assets/Bild_4.png");

const Container = styled.div`
  background: white;
  padding: 20px;
  min-height: 100%;
`;

const Content = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
`;

const Section = styled.section`
  margin-bottom: 32px;
`;

const FoerderLogo = styled.img`
  max-height: 80px;
  margin-top: 12px;
`;

const MaterialGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const MaterialCard = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
`;

const MaterialImage = styled.img`
  width: 100%;
  display: block;
  cursor: zoom-in;
`;

const MaterialLabel = styled.div`
  padding: 10px 14px;
  font-size: 13px;
  color: #495057;
`;

const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  cursor: zoom-out;
`;

const LightboxImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
`;

const LightboxClose = styled.button`
  position: fixed;
  top: 20px;
  right: 24px;
  background: none;
  border: none;
  color: white;
  font-size: 36px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.8;
  &:hover { opacity: 1; }
`;

export const VerwendungshinweisRoute = React.memo(
  function VerwendungshinweisRoute() {
    const [lightboxSrc, setLightboxSrc] = React.useState<string | null>(null);

    React.useEffect(() => {
      if (!lightboxSrc) return;
      const handler = (e: KeyboardEvent) => {
        if (e.key === "Escape") setLightboxSrc(null);
      };
      window.addEventListener("keydown", handler);
      return () => window.removeEventListener("keydown", handler);
    }, [lightboxSrc]);

    return (
      <AppLayout fullWidth>
        {lightboxSrc && (
          <LightboxOverlay onClick={() => setLightboxSrc(null)}>
            <LightboxClose onClick={() => setLightboxSrc(null)}>&times;</LightboxClose>
            <LightboxImage
              src={lightboxSrc}
              alt="Vollansicht"
              onClick={(e) => e.stopPropagation()}
            />
          </LightboxOverlay>
        )}
        <Container>
          <Content>
            <h1>Hinweise zur Verwendung</h1>

            <Section>
              <p>
                Diese Website ist eine frei zugängliche Wissensplattform zum
                Thema Wasser. Die Inhalte richten sich an Bürgerinnen und Bürger
                und dürfen von Stadtwerken, Wasserverbänden, Kommunen sowie
                weiteren interessierten Dritten kostenfrei zur Information und
                Aufklärung eingebunden und genutzt werden.
              </p>
              <p>
                Sie dürfen gerne auf Ihrer eigenen Website auf diese Plattform
                verlinken und die Inhalte so Ihren Kundinnen und Kunden sowie
                Bürgerinnen und Bürgern zugänglich machen.
              </p>
              <p>
                Die bereitgestellten Informationen wurden mit größtmöglicher
                Sorgfalt erstellt. Dennoch übernehmen wir keine Gewähr für die
                Richtigkeit, Vollständigkeit, Aktualität oder Eignung der
                Inhalte für bestimmte Zwecke. Eine Haftung für Schäden
                materieller oder immaterieller Art, die durch die Nutzung oder
                Nichtnutzung der angebotenen Informationen entstehen, ist
                ausgeschlossen, sofern kein nachweislich vorsätzliches oder grob
                fahrlässiges Verschulden vorliegt.
              </p>
              <p>
                Soweit möglich, sind externe Quellen angegeben und zitiert. Für
                die Inhalte verlinkter externer Websites übernehmen wir keine
                Verantwortung. Zum Zeitpunkt der Verlinkung waren keine
                rechtswidrigen Inhalte erkennbar; auf die aktuelle und
                zukünftige Gestaltung sowie den Inhalt der verlinkten Seiten
                haben wir jedoch keinen Einfluss.
              </p>
              <p>
                Die Nutzung der Inhalte erfolgt auf eigenes Risiko, die Inhalte
                dieser Plattform ersetzen keine fachliche, rechtliche oder
                technische Beratung.
              </p>
              <p>
                Bei Interesse an einer individualisierten Einbindung
                kontaktieren Sie uns gerne per E-Mail an{" "}
                <a href="mailto:schulzesturm@asew.de">schulzesturm@asew.de</a>.
              </p>
            </Section>

            <Section>
              <h2>Über das Forschungsprojekt</h2>
              <p>
                Das Forschungsprojekt CrowdWater untersucht, wie durch
                dezentrales, digitales Monitoring eine nachhaltigere Regen- und
                Trinkwassernutzung erreicht werden kann. Ziel ist es, belastbare
                Informationen über Wasserverbräuche, Einsparpotenziale und den
                Einfluss von Klimawandel und Wetter auf regionale Wassermengen
                zu gewinnen. Dazu werden in ausgewählten Haushalten und
                Unternehmen Sensoren installiert, die Wasserdaten entlang des
                Nutzungskreislaufs in Echtzeit erfassen. Diese Daten fließen in
                eine zentrale Plattform ein und ermöglichen eine transparente
                Auswertung sowie die Entwicklung intelligenter Steuerungs- und
                Prognosemodelle. CrowdWater verfolgt dabei einen
                Living-Lab-Ansatz: Technik, Wissenschaft, Kommunen und
                Nutzerinnen und Nutzer arbeiten unter realen Bedingungen
                zusammen. Ergänzt wird das technische Monitoring durch
                Informations- und Bildungsangebote, um das Bewusstsein für
                nachhaltige Wassernutzung zu stärken und konkrete
                Einsparmaßnahmen anzustoßen. Ziel ist es, Wassermanagement
                datenbasiert, nutzerorientiert und zukunftsfähig zu gestalten.
              </p>
              <p>
                Weitere Informationen zum Projekt finden Sie unter:{" "}
                <a
                  href="https://crowdwater.info/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://crowdwater.info/
                </a>
              </p>
            </Section>

            <Section>
              <h2>Einbindungsmaterialien</h2>
              <p>
                Folgende Grafiken stehen zur freien Verwendung bereit. Sie
                dürfen diese Bilder auf Ihrer Website einsetzen – als
                Werbegrafik oder als anklickbares Bild mit Link zum
                Wassererklärer.
              </p>
              <MaterialGrid>
                <MaterialCard>
                  <MaterialImage src={bild1} alt="Wassererklärer Grafik 1 – Hintergrundmotiv" onClick={() => setLightboxSrc(bild1)} />
                  <MaterialLabel>Grafik 1 – geeignet als Werbebanner</MaterialLabel>
                </MaterialCard>
                <MaterialCard>
                  <MaterialImage src={bild2} alt="Wassererklärer Grafik 2 – Textbanner Zum Wassererklärer" onClick={() => setLightboxSrc(bild2)} />
                  <MaterialLabel>Grafik 2 – geeignet als Link-Bild</MaterialLabel>
                </MaterialCard>
                <MaterialCard>
                  <MaterialImage src={bild3} alt="Wassererklärer Grafik 3 – Themenübersicht" onClick={() => setLightboxSrc(bild3)} />
                  <MaterialLabel>Grafik 3 – geeignet als Werbebanner</MaterialLabel>
                </MaterialCard>
                <MaterialCard>
                  <MaterialImage src={bild4} alt="Wassererklärer Grafik 4 – Iconbanner mit Button" onClick={() => setLightboxSrc(bild4)} />
                  <MaterialLabel>Grafik 4 – geeignet als Link-Bild</MaterialLabel>
                </MaterialCard>
              </MaterialGrid>
            </Section>

            <Section>
              <h2>Hinweise zur Förderung</h2>
              <p>
                Der Wassererklärer ist im Rahmen des Forschungsprojektes
                „CrowdWater" entstanden.
              </p>
            </Section>

            <Section>
              <p>
                <strong>Gefördert durch:</strong>
              </p>
              <FoerderLogo src={bmftrLogo} alt="BMFTR Förderlogo" />
            </Section>
          </Content>
        </Container>
      </AppLayout>
    );
  }
);
